import React, {Component} from 'react';
import PropTypes from 'prop-types';
import muiThemeable from 'material-ui/styles/muiThemeable';
import {Table, TableHeader, TableRow} from 'material-ui/Table';
import DatagridHeaderCell from 'admin-on-rest/lib/mui/list/DatagridHeaderCell';
import DatagridBodyLocationAudit from './DatagridBodyLocationAudit';

const defaultStyles = {
    table: {
        tableLayout: 'auto',
    },
    tbody: {
        height: 'inherit',
    },
    header: {
        th: {
            padding: 0,
        },
        'th:first-child': {
            padding: '0 0 0 12px',
        },
    },
    cell: {
        td: {
            padding: '0 12px',
            whiteSpace: 'normal',
            overflow: 'visible',
        },
        'td:first-child': {
            padding: '0 12px 0 16px',
            whiteSpace: 'normal',
        },
    },
    auditRow: {overflow: 'visible'},
    auditCell: {overflow: 'visible'},
    auditResultRow: {height: 'auto'}
};

/**
 * The DatagridLocationAudit component duplicates the AOR Datagrid, which renders a list of records as a table.
 * It loads a DatagridBodyLocationAudit, which displays list items and an additional row for child data.
 *
 */
class DatagridLocationAudit extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentToggle: {},
        };
    }

    componentWillMount() {
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.currentToggle !== this.props.currentToggle) {
            // Check for update to current toggle object (if state/props is used)
            this.setState({
                currentToggle: nextProps.currentToggle,
            });
        }
    }

    updateSort = event => {
        event.stopPropagation();
        this.props.setSort(event.currentTarget.dataset.sort);
    };

    // Convert the ids list to a list of ids and expandable prop
    createIdsList = (ids, data) => {
        if (ids && ids.length) {
            const idsList = [];
            ids.map((id, idx) => {
                return idsList.push({
                    id: id,
                    expanded: false,
                    viewed: false,
                });
            });
            return idsList;
        }
        return []
    };

    render() {
        const {
            resource,
            children,
            columns,
            currentToggle,
            eventEmitter,
            isLoading,
            data,
            currentSort,
            ids,
            basePath,
            styles = defaultStyles,
            muiTheme,
            options,
            headerOptions,
            bodyOptions,
            rowOptions,
            toggleEventName,
        } = this.props;

        const idsList = this.createIdsList(ids, data);

        return (
            <Table
                style={options && options.fixedHeader ? null : styles.table}
                fixedHeader={false}
                {...options}
            >
                <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                    {...headerOptions}
                >
                    <TableRow style={muiTheme.tableRow}>
                        {React.Children.map(
                            children,
                            (field, index) =>
                                field ? (
                                    <DatagridHeaderCell
                                        key={field.props.source || index}
                                        field={field}
                                        defaultStyle={
                                            index === 0 ? (
                                                styles.header['th:first-child']
                                            ) : (
                                                styles.header.th
                                            )
                                        }
                                        currentSort={currentSort}
                                        isSorting={
                                            field.props.source ===
                                            currentSort.field
                                        }
                                        updateSort={this.updateSort}
                                        resource={resource}
                                    />
                                ) : null
                        )}
                    </TableRow>
                </TableHeader>
                <DatagridBodyLocationAudit
                    resource={resource}
                    eventEmitter={eventEmitter}
                    idsList={idsList}
                    columns={columns}
                    currentToggle={currentToggle}
                    data={data}
                    basePath={basePath}
                    styles={styles}
                    isLoading={isLoading}
                    options={bodyOptions}
                    rowOptions={rowOptions}
                    toggleEventName={toggleEventName}
                >
                    {children}
                </DatagridBodyLocationAudit>
            </Table>
        );
    }
}

DatagridLocationAudit.propTypes = {
    basePath: PropTypes.string,
    bodyOptions: PropTypes.object,
    columns: PropTypes.number,
    currentSort: PropTypes.shape({
        sort: PropTypes.string,
        order: PropTypes.string,
    }),
    currentToggle: PropTypes.object,
    data: PropTypes.object.isRequired,
    eventEmitter: PropTypes.any,
    headerOptions: PropTypes.object,
    ids: PropTypes.arrayOf(PropTypes.any).isRequired,
    isLoading: PropTypes.bool,
    muiTheme: PropTypes.object,
    options: PropTypes.object,
    resource: PropTypes.string,
    rowOptions: PropTypes.object,
    setSort: PropTypes.func,
    styles: PropTypes.object,
    toggleEventName: PropTypes.string,
};

DatagridLocationAudit.defaultProps = {
    columns: 1,
    currentToggle: {},
    data: {},
    ids: [],
    toggleEventName: 'locationAuditToggle',
};

export default muiThemeable()(DatagridLocationAudit);



// WEBPACK FOOTER //
// ./src/Fuse/admin/DatagridLocationAudit.js